import api from '@anm/api';
import { BrandLogoPrams, CreateBrandFileRequest, DeleteLogoParams } from '@anm/api/modules/brands';
import { getAuthToken } from '@anm/auth/helpers/authToken';
import asyncEntity from '@anm/helpers/redux/asyncEntity';
import { call, fork, take } from '@anm/helpers/saga/effects';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { brandActions } from '.';

const fetchBrandsAsync = asyncEntity(brandActions.fetchBrandsAsync, () => api().brands.fetchBrands());

const createBrandFileAsync = asyncEntity(brandActions.createBrandFileAsync, (data: CreateBrandFileRequest) =>
  api().brands.createBrandFile(data)
);

function* watchFetchBrands() {
  while (true) {
    yield take(getType(brandActions.fetchBrands));

    yield fork(fetchBrandsAsync);
  }
}

function* watchCreateBrandFile() {
  while (true) {
    const { payload }: ReturnType<typeof brandActions.createBrandFile> = yield take(
      getType(brandActions.createBrandFile)
    );

    yield call(createBrandFileAsync, payload);
  }
}

const uploadBrandLogoAsync = asyncEntity(brandActions.uploadBrandLogoAsync, (params: BrandLogoPrams) =>
  api().brands.uploadBrandLogo(params)
);

const deleteBrandLogoAsync = asyncEntity(brandActions.deleteBrandLogoAsync, (params: DeleteLogoParams) =>
  api().brands.deleteBrandLogo(params)
);

function* watchUploadBrandLogo() {
  while (true) {
    const { payload }: ReturnType<typeof brandActions.uploadBrandLogo> = yield take(
      getType(brandActions.uploadBrandLogo)
    );

    const token: ReturnType<typeof getAuthToken> = yield getAuthToken();
    const params = {
      token,
      ...payload
    };

    yield fork(uploadBrandLogoAsync, params);
  }
}

function* watchDeleteBrandLogo() {
  while (true) {
    const { payload }: ReturnType<typeof brandActions.deleteBrandLogo> = yield take(
      getType(brandActions.deleteBrandLogo)
    );

    yield call(deleteBrandLogoAsync, payload, payload);
  }
}

export default () => [
  call(watchFetchBrands),
  call(watchCreateBrandFile),
  call(watchUploadBrandLogo),
  call(watchDeleteBrandLogo)
];
